import { WorkData } from '../types';
import aiVideoTranscriptionAutomation from './work/cases/ai-video-transcription-automation';
import developmentOfRobinwichmannCom from './work/cases/development-of-robinwichmann_com';

const workData: WorkData = {
  title: "Meine Arbeiten",
  intro: "Hier findest Du eine Auswahl meiner aktuellen Projekte. Jedes Projekt steht für meinen Ansatz, innovatives Design mit technischer Exzellenz zu verbinden.",
  previewNotAvailable: "Vorschau nicht verfügbar",
  moreDetails: "Mehr details",
  contactCta: {
    text: "Interessiert an einer Zusammenarbeit oder hast Du Fragen zu meinen Projekten?",
    buttonText: "Kontaktiere mich"
  },

  // Work Cases
  cases: [
    developmentOfRobinwichmannCom,
    aiVideoTranscriptionAutomation
  ]
};

export default workData;